import * as oauth from 'oauth4webapi';

import { AuthConfig } from '../SciFinderAuthProvider';

import { getClient, fetchSSOServerMetadata } from './ssoConfig';

export async function fetchToken(state: string, codeVerifier: string, redirectUrl: string, authConfig: AuthConfig) {
  const ssoMetadata = await fetchSSOServerMetadata(authConfig);
  const currentUrl = new URL(window.location.href);

  const client = await getClient(authConfig);

  const validatedParams = oauth.validateAuthResponse(ssoMetadata, client, currentUrl, state);
  if (oauth.isOAuth2Error(validatedParams)) {
    throw new Error('Failed to authenticate in SciFinder: Invalid OAuth2 params.');
  }

  const response = await oauth.authorizationCodeGrantRequest(
    ssoMetadata,
    client,
    validatedParams,
    redirectUrl,
    codeVerifier
  );

  const challenges = oauth.parseWwwAuthenticateChallenges(response);
  if (challenges) {
    throw new Error(`Failed to authenticate in SciFinder: Challenges ${challenges.join(', ')}.`);
  }

  const result = await oauth.processAuthorizationCodeOpenIDResponse(ssoMetadata, client, response);
  if (oauth.isOAuth2Error(result)) {
    throw new Error('Failed to authenticate in SciFinder: Invalid OAuth2 response.');
  }

  return result;
}
